import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/ResourcesNotReadyYet';
import Image from '../../objects/image/SecondaryImage';
import LibraryImage from '../../objects/image/SecondaryLibraryImage';
import ProtoType from '../../objects/prototypeObjects/PrototypeResourceScroll';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import {getAssetComponentByType} from '../../../helpers/componentHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import _ from 'lodash';
import * as animationHelper from "../../../helpers/animationHelper";

class ResourcesScrollScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            showContentOutlineInPreview: props.showContentOutlineInPreview,
            is_resource_screen: appHelper.isDefined(this.props.screen.is_resource_screen) && this.props.screen.is_resource_screen,
            locale: {},
            status: objectConstants.STATUS_NOT_STARTED,
            multiPath: appHelper.isDefined(this.props.screen.multi_path) ? this.props.screen.multi_path : {enabled: false},
            allowReviewMode: true,
            reviewMode: false,
            propsUpdated: false,
            renderedObjects: [],
            updateCharacter: false,
            screenCharacter: {},
            assets: {
                background: {
                    src: "",
                    type: "",
                    type_id: ""
                },
                screenAsset: {
                    src: "",
                    pose: "",
                    position: ""
                }
            },
            callbacks: {
                updateCharacterExpression: null,
                onObjectComplete: null,
            },
            currentObjectIndex: 0,
            showProgression: false,
            imageIsTracking: false,
            allowGoToScreen: false,
            goToScreenId: 0,
            terminateScreen: false,
            terminateBite: false,
            producerNotes: appHelper.getScreenNotes(this.props.parentScreen, this.props.screen, this.props.showContentOutlineInPreview, props.contentData.experience.is_preview),
            screenIsReady: this.props.screen.objects.length > 0,
            continue_label: appHelper.getLocaleString("continue_label"),

        };
        this.getLocale = this.getLocale.bind(this);
        this.getObject = _.debounce(this.getObject.bind(this), 300);
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.isReviewMode = this.isReviewMode.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.storeUserResponse = this.storeUserResponse.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.updateCharacterExpression = this.updateCharacterExpression.bind(this);
        this.onObjectComplete = this.onObjectComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.showProgressionButton = this.showProgressionButton.bind(this);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
        this.onScrollComplete = this.onScrollComplete.bind(this);
        this.onContinueBtnReveled = this.onContinueBtnReveled.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setReviewMode = this.setReviewMode.bind(this);
        this.renderAllObjects = this.renderAllObjects.bind(this);
        this.transitionCharacterExpressions = this.transitionCharacterExpressions.bind(this);
        this.transitionCharacter = this.transitionCharacter.bind(this);
        this.transitionPrevCharacter = this.transitionPrevCharacter.bind(this);
        this.goToScreen = this.goToScreen.bind(this);
        //new
        this.getCharacterName = this.getCharacterName.bind(this);
        this.handleObjectProgression = this.handleObjectProgression.bind(this);
        this.hasNextObject = this.hasNextObject.bind(this);
        this.getLayoutClass = this.getLayoutClass.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getSubScreenParent = this.getSubScreenParent.bind(this);
        this.checkIsResourceScreen = this.checkIsResourceScreen.bind(this);
        this.updateResourceObjectResult = this.updateResourceObjectResult.bind(this);
        this.updateResourceScreenResult = this.updateResourceScreenResult.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.onObjectRendered = this.onObjectRendered.bind(this);

        this.feed = React.createRef();
        this.bottomAnchor = React.createRef();
    }

    componentDidMount() {
        if(this.props.audio.audioRef.length > 0){
            this.props.actions.clearAudio();
        }
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(true);
        this.setCallbacks();
        this.getLocale();
        if(this.state.screenIsReady) {
            this.getObject(this.state.currentObjectIndex);
        }else{
            this.setScreenNotReadyYet();
        }
        this.getAssets();
        this.checkScreenStatus();
    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = {};
        if(this.state.is_resource_screen){
            screenUserData = userDataHelper.getResourceScreenUserData(nextProps.userData, this.state.screen.screen_id);
        }else if(this.props.parentScreen){
            screenUserData = userDataHelper.getSubScreenUserData(nextProps.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);

        }else{
            screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        }
        this.setState({userData: Object.assign({}, nextProps.userData)});

        if(this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE){
            this.setState({
                status: screenUserData.status,
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                continue_label: appHelper.getLocaleString("continue_label"),
            });

        }

        if(this.state.showContentOutlineInPreview !== nextProps.showContentOutlineInPreview){
            this.setState({
                showContentOutlineInPreview: nextProps.showContentOutlineInPreview,
                producerNotes: appHelper.getScreenNotes(this.props.parentScreen, this.state.screen, nextProps.showContentOutlineInPreview, this.props.contentData.experience.is_preview),
            });
        }
    }

    componentDidUpdate() {
        if (this.state.propsUpdated && this.state.reviewMode && this.state.allowReviewMode) {
            this.setReviewMode();
        }

        if (this.state.updateCharacter) {

            this.transitionCharacterExpressions();
        }
    }

    componentWillUnmount(){
        this.props.actions.clearAudio();
    }

    setScreenAccessed(){
        //this.props.actions.setScreenAccessed(this.state.screen);
    }

    setScreenNotReadyYet(){
        let completionData =  {
            screen_status:  objectConstants.STATUS_COMPLETE,
            sub_screen_complete: appHelper.isDefined(this.props.parentScreen) ? true : undefined
        };

        this.showProgressionButton();

        this.updateScreenResults(completionData);
    }

    checkScreenStatus() {
        let screenUserData = {};
        if(this.state.is_resource_screen){
            screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.screen.screen_id);
        }else if(this.props.parentScreen){
            screenUserData = userDataHelper.getSubScreenUserData(this.state.userData, this.props.parentScreen.screen_id, this.state.screen.screen_id);

        }else{
            screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        }

        if(this.state.status !== screenUserData.status && screenUserData.status === objectConstants.STATUS_COMPLETE){
            this.setState({
                status: screenUserData.status,
            });
        }
        /* let screenStatus = getScreenUserData(this.props.userData, this.props.screen.screen_id).status;
         let reviewMode = screenStatus === objectConstants.STATUS_COMPLETE && localStorage.post_completion_mode === appConstants.POST_COMPLETION_MODE_REVIEW;
        // console.log(`reviewMode: ${this.state.reviewMode} - line 120`);
         this.setState({status: screenStatus, checkCompletionStatus: true, reviewMode: reviewMode, propsUpdated: true});
         */
    }

    setCallbacks() {
        //console.log(`reviewMode: ${this.state.reviewMode} - line 125`);
        this.setState({
            callbacks: Object.assign({}, this.state.biteCallbacks, {
                updateCharacterExpression: this.updateCharacterExpression,
                onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                storeUserResponse: this.storeUserResponse,
                scrollTo: this.scrollTo,
                isReviewMode: this.isReviewMode,
                getCharacterName: this.getCharacterName,
                hasNextObject: this.hasNextObject,
                navigateToNextScreen: this.navigateToNextScreen,
                getScreenStatus: this.getScreenStatus,
                getSubScreenParent: this.getSubScreenParent,
                checkIsResourceScreen: this.checkIsResourceScreen,
                goToScreen: this.goToScreen,
                onObjectRendered: this.onObjectRendered
            })
        });
    }

    getSubScreenParent(){
        return appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen : undefined;
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.screen);
        this.setState({locale: Object.assign({}, locale)});
        //if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
        if (!appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen) {
            this.props.actions.setScreenTitle(locale.title);
        }
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {

        return this.props.biteCallbacks.getBiteId();
    }

    isReviewMode() {
        return this.state.reviewMode;
    }

    getCharacterName() {
        return this.state.locale.character_name;
    }

    getScreenStatus(){
        return this.state.status;
    }

    checkIsResourceScreen(){
        return this.state.is_resource_screen;
    }

    setReviewMode() {

        let objectsToRender = appHelper.getRenderableObjects(this.props.userData, this.getBiteId(), this.state.screen.objects);
        this.setState(
            {
                screen: Object.assign({}, this.state.screen, {
                    objects: Object.assign([], objectsToRender)
                }),
                propsUpdated: false
            }
        );
        this.renderAllObjects(objectsToRender);
    }

    renderAllObjects(objectsToRender) {
        let renderableObjects = [];
        for (let i = 0; i < objectsToRender.length; i++) {
            let object = objectsToRender[i];
            let objectType = Object.assign({}, getAssetComponentByType(object.asset_type_code),
                {
                    data: object
                }
            );
            renderableObjects = dataHelper.immutablePush(renderableObjects, objectType);
        }
        this.setState({renderedObjects: Object.assign([], renderableObjects), showProgression: true});
    }

    getObject(index) {
        let object = this.state.screen.objects[index];
        let objectType = Object.assign({}, getAssetComponentByType(object.asset_type_code),
            {
                data: object
            }
        );
        //console.log(objectType);
        //let objectLocale = appHelper.getLocalData(object.locale);
        //this.props.actions.setScreenTitle(objectLocale.title);
        this.setState({renderedObjects: Object.assign([], dataHelper.immutablePush(this.state.renderedObjects, objectType))});
    }

    getAssets() {
        let backgroundAsset = Object.assign(this.state.assets.background);
        let hasLeftAsset = appHelper.isDefined(this.state.screen.assets.left);
        let hasRightAsset = appHelper.isDefined(this.state.screen.assets.right);
        let screenAsset = {};
        if(hasLeftAsset){
            screenAsset = this.getAssetType(this.state.screen.assets.left);
        }else if(hasRightAsset){
            screenAsset = this.getAssetType(this.state.screen.assets.right);
        }

        if (appHelper.isDefined(this.state.screen.assets.background)) {
            backgroundAsset = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: backgroundAsset,
                screenAsset: screenAsset
            })
        });

    }

    getAssetType(asset){
        let returnAsset = {};
        if(asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER){
            let screenCharacter = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(screenCharacter, asset);
        }else if(asset.constant === assetConstants.ASSET_TYPE_ICON){
            returnAsset = appHelper.getIconAsset(asset);
        }else if(asset.constant === assetConstants.ASSET_TYPE_IMAGE){
            returnAsset = appHelper.getImageAsset(asset);
        }else if(asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE){
            returnAsset = appHelper.getLibraryImageAsset(asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if(appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)){
            returnAsset = Object.assign({},returnAsset,{
                type: asset.constant
            });
        }

        return returnAsset;
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    updateCharacterExpression(pose) {
        /*if (appHelper.isDefined(pose) && pose.pose !== objectConstants.INHERIT) {
            let characterAsset = appHelper.getCharacterPose(this.state.screenCharacter, pose);
            if (appHelper.isDefined(characterAsset.src) && characterAsset.src.length > 0) {
                let characterRef = this.refs.character;
                characterRef.removeAttribute("style");
                TweenLite.set(characterRef, {opacity: 0, '-webkit-filter': 'blur(5px)', 'filter': 'blur(5px)'});

                if (appHelper.isDefined(this.refs.prevCharacter)) {
                    let prevCharacterRef = this.refs.prevCharacter;
                    prevCharacterRef.removeAttribute("style");
                    TweenLite.set(prevCharacterRef, {opacity: 1, '-webkit-filter': 'blur(0px)', 'filter': 'blur(0px)'});
                }

                //if (characterAsset.src !== this.state.assets.character.src) {
                this.setState({
                    assets: Object.assign({}, this.state.assets, {
                        character: characterAsset,
                        prevCharacter: this.state.assets.character,

                    }),
                    updateCharacter: true
                });
            }
        }
        //}*/
    }

    transitionCharacterExpressions() {
        this.setState({updateCharacter: false});
        this.transitionPrevCharacter();
        this.transitionCharacter();

    }

    transitionCharacter() {
       /* let characterRef = this.refs.character;

        TweenLite.to(characterRef, 0.6, {
            opacity: 1,
            filter: 'blur(0px)',
            ease: Expo.easeOut
        });*/
    }

    transitionPrevCharacter() {
        /* let characterRef = this.refs.character;

        TweenLite.to(characterRef, 0.6, {
            opacity: 1,
            filter: 'blur(0px)',
            ease: Expo.easeOut
        });*/
    }

    storeUserResponse(responseObj) {
        let params = Object.assign({}, responseObj, {
            userData: this.props.userData,
            bite_id: this.getBiteId(),
            parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
            screen_id: this.getScreenId(),

        });

        this.props.actions.storeUserResponse(params).then((userData) => {
            this.props.actions.setSuspendData(userData);
        }).catch(error => {
        });
    }


    navigateToNextScreen() {
        if (appHelper.isDefined(this.props.parentScreen)) {
            if(appHelper.isDefined(this.props.closeDialog)){
                this.props.closeDialog();
            }
            if (this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
                this.goToScreen(this.state.goToScreenId);
            } else if (this.state.terminateScreen) {
                let nextScreenId = appHelper.getNextScreenId(this.props.parentScreen.screen_id);
                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                    this.context.router.push('menu');
                } else {
                    this.props.actions.setNextLessonLocation(nextScreenId);
                }
            } else if(this.state.terminateBite){
                if (localStorage.bites.length > 1) {
                    this.context.router.push('menu');
                }else{
                    let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                    this.goToScreen(bite.screens[0].screen_id);
                }
            }else {
                this.props.biteCallbacks.goToNextSubScreen(this.state.screen);
            }
        } else {
            if(this.state.allowGoToScreen && !isNaN(parseInt(this.state.goToScreenId))) {
                this.goToScreen(this.state.goToScreenId);
            } else if(this.state.terminateBite){
                if (localStorage.bites.length > 1) {
                    this.context.router.push('menu');
                }else{
                    let bite = appHelper.getBiteById(this.props.biteCallbacks.getBiteId());
                    this.goToScreen(bite.screens[0].screen_id);
                }
            } else {
                let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
                if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                    this.context.router.push('menu');
                } else {
                    this.props.actions.setNextLessonLocation(this.getScreenId());
                }
            }
        }
    }

    goToScreen(goTo) {
        this.props.actions.setNewLessonLocation(goTo);

    }

    handleObjectProgression() {

    }

    onObjectRendered() {
        if (this.state.currentObjectIndex < (this.state.screen.objects.length - 1)) {
            let newIndex = this.state.currentObjectIndex + 1;
            this.setState({currentObjectIndex: newIndex});
            this.getObject(newIndex);

            //this.updateResourceObjectResult(completionData);

        } else {
           // this.updateResourceObjectResult(completionData);
        }
    }

    onObjectComplete(completionData) {

        this.updateResourceObjectResult(completionData);

    }

    updateScreenResults(completionData) {
        let params = Object.assign({}, completionData, {
            bite_id: this.getBiteId(),
            parent_screen_id: appHelper.isDefined(this.props.parentScreen) ? this.props.parentScreen.screen_id : undefined,
            screen_id: this.getScreenId(),
            object_status: completionData.status,
            object_result: {}
        });



        this.props.actions.updateScreenResults(params).then((userData) => {
            if(appHelper.isDefined(completionData.sub_screen_complete) && completionData.sub_screen_complete){
                this.props.biteCallbacks.onSubScreenComplete(this.state.screen);
            }
            this.props.actions.setSuspendData(userData).then((trackingData) => {

                if(completionData.screen_status === objectConstants.STATUS_COMPLETE){
                    this.props.actions.setScreenComplete(this.state.screen);
                }

            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    updateResourceObjectResult(completionData){
        let params = Object.assign({}, completionData, {
            screen_id: this.getScreenId(),
            object_status: completionData.status,

        });
        this.props.actions.updateResourceObjectResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                let resourceScreen = appHelper.getArrayObjectByKey(userData.resources,"screen_id",this.state.screen.screen_id);
                if(resourceScreen.status === objectConstants.STATUS_COMPLETE){
                    if(completionData.screen_status === objectConstants.STATUS_COMPLETE){
                        this.props.actions.setScreenComplete(this.state.screen);
                    }
                }
            }).catch(error => {});
        }).catch(error => {
        });
    }

    updateResourceScreenResult(completionData){
        let params = Object.assign({}, completionData, {
            screen_id: this.getScreenId(),
            object_status: completionData.status,
            screen_status:  objectConstants.STATUS_COMPLETE
        });
        this.props.actions.updateResourceScreenResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if(completionData.screen_status === objectConstants.STATUS_COMPLETE){
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {});
        }).catch(error => {
        });
    }

    showProgressionButton() {
        let nextScreenId = appHelper.getNextScreenId(this.state.screen.screen_id);
        //if (nextScreenId.length > 0) {
        this.setState({showProgression: true});
        //}
    }

    scrollTo(pos) {
        if(this.state.status !== objectConstants.STATUS_COMPLETE) {
            let feed = this.feed.current;

            let params = {
                ele: feed,
                duration: objectConstants.SCROLL_TO_DURATION,
                delay: 0,
                scrollTop: pos,
                callback: this.onScrollComplete
            };

            animationHelper.scrollTo(params);
        }
    }

    onContinueBtnReveled() {
        this.scrollToTop();
    }

    scrollToTop() {
        if(this.state.status !== objectConstants.STATUS_COMPLETE) {
            let anchor = this.bottomAnchor.current;
            let scrollTo = this.scrollTo;
            if(appHelper.isEleDefined(anchor)) {
                setTimeout(function () {
                    scrollTo(anchor.offsetTop);

                }, 1000);
            }
        }
    }

    onScrollComplete() {

    }

    hasNextObject(object) {
        let objectIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.objects, "asset_id", object.asset_id);
        return objectIndex < (this.state.screen.objects.length - 1);
    }

    getLayoutClass(){
        if(appHelper.isDefined(this.state.screen.assets.left) && this.state.screenIsReady ){
            return 'left-asset-screen';
        }else if(appHelper.isDefined(this.state.screen.assets.right) && this.state.screenIsReady ){
            return 'right-asset-screen';
        }else{
            return 'full-screen';
        }
    }

    render() {
        return (
            <div className="content-screen">
                <div className="background-container">
                    {
                        !appHelper.isDefined(this.props.parentScreen) && !this.state.is_resource_screen
                            ?
                            <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                            :
                            null
                    }
                </div>
                <div className="screen-container">
                    <div className="content-wrapper" id={`${this.state.screen.screen_id}_feed_id`} ref={this.feed}>

                        {
                            appHelper.isDefined(this.state.screen.assets.left) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady
                                ?
                                <div className="asset-col-left">
                                    {this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE || this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_LIBRARY_IMAGE
                                        ?
                                        this.state.assets.screenAsset.type  === assetConstants.ASSET_TYPE_IMAGE
                                            ?
                                            <Image screenObject={this.state.screen.assets.left}/>
                                            :
                                            <LibraryImage screenObject={this.state.screen.assets.left}/>
                                        :
                                        <img src={this.getImagePath(this.state.assets.screenAsset.src)} alt=""/>
                                    }
                                </div>
                                :
                                null
                        }
                        <div className={`${this.getLayoutClass()} `} role="feed">
                            {
                                this.state.producerNotes.show_notes || !this.state.screenIsReady || !this.state.producerNotes.show_content
                                    ?
                                    <div className="floating-notes">
                                        {
                                            this.state.producerNotes.show_notes
                                                ?
                                                <ProducerNotes notes={this.state.producerNotes.notes}
                                                               screen_id={this.state.screen.screen_id}/>
                                                :
                                                null
                                        }
                                        {
                                            !this.state.screenIsReady || !this.state.producerNotes.show_content
                                                ?
                                                <NotReadyYet screen_id={this.state.screen.screen_id}
                                                             onContinue={this.props.biteCallbacks.getNextResource}
                                                             onClose={this.props.biteCallbacks.closeResources}
                                                             hasNextResource={this.props.biteCallbacks.hasNextResource}
                                                />
                                                :
                                                null
                                        }
                                    </div>
                                    :
                                    null
                            }

                            {
                                this.state.screenIsReady && this.state.producerNotes.show_content && this.state.renderedObjects.length > 0
                                    ?
                                    this.state.renderedObjects.map((object,index) =>
                                        <div className="feed-object-container" key={index} role="article" tabIndex="0"  id={`object_${object.data.asset_id}`}>
                                            <object.component screenObject={object.data} callbacks={this.state.callbacks} index={index}/>
                                        </div>
                                    )
                                    :
                                    null
                            }

                            {
                                !this.state.screenIsReady || !this.state.producerNotes.show_content
                                    ?
                                    <div className="feed-object-container">
                                        <ProtoType />
                                    </div>
                                    :
                                    null
                            }

                            {this.state.showProgression
                                ? <Button ref={`${this.state.screen.screen_id}_button`}
                                          label={this.state.continue_label}
                                          id={`${this.state.screen.screen_id}_button`}
                                          onClick={this.navigateToNextScreen}
                                          onRevealed={this.onContinueBtnReveled}
                                />
                                : null
                            }
                            <div ref={this.bottomAnchor}/>
                        </div>
                        {
                            appHelper.isDefined(this.state.screen.assets.right) && appHelper.isDefined(this.state.assets.screenAsset) && this.state.assets.screenAsset.src.length > 0 && this.state.screenIsReady
                                ?
                                <div className="asset-col-right">
                                    {this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_IMAGE || this.state.assets.screenAsset.type === assetConstants.ASSET_TYPE_LIBRARY_IMAGE
                                        ?
                                        this.state.assets.screenAsset.type  === assetConstants.ASSET_TYPE_IMAGE
                                            ?
                                            <Image screenObject={this.state.screen.assets.right}/>
                                            :
                                            <LibraryImage screenObject={this.state.screen.assets.right}/>

                                        :
                                        <img src={this.getImagePath(this.state.assets.screenAsset.src)} alt=""/>
                                    }
                                </div>
                                :
                                null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

ResourcesScrollScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    parentScreen: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    audio:PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    closeDialog: PropTypes.func,
    showContentOutlineInPreview: PropTypes.bool.isRequired,
};

ResourcesScrollScreen.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData,
        audio: state.audio,
        showContentOutlineInPreview: state.showContentOutlineInPreview,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourcesScrollScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/resourcesScrollScreen/ResourcesScrollScreen.js
 **/